import { c as _c } from "react/compiler-runtime";
import { getOrgArtifactsQueryKey } from '@onefootprint/fetch-dashboard';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { isUnresolvedArtifactSelection } from '../utils/is-unresolved-artifact-selection';
type UseResolveSelectedArtifactArgs = {
  selectedOptionId: string;
  artifacts: {
    id: string;
  }[];
  investigationId: string;
};

// A just-generated artifact may be missing from the cached list (its create frame can
// be lost over the websocket), so the selected id won't resolve. Refetch this
// investigation's artifacts once per id to pull it in without a reload.
const useResolveSelectedArtifact = t0 => {
  const $ = _c(7);
  const {
    selectedOptionId,
    artifacts,
    investigationId
  } = t0;
  const queryClient = useQueryClient();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Set();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const refetchedRef = useRef(t1);
  let t2;
  let t3;
  if ($[1] !== artifacts || $[2] !== investigationId || $[3] !== queryClient || $[4] !== selectedOptionId) {
    t2 = () => {
      if (!isUnresolvedArtifactSelection(selectedOptionId, artifacts)) {
        return;
      }
      if (refetchedRef.current.has(selectedOptionId)) {
        return;
      }
      refetchedRef.current.add(selectedOptionId);
      queryClient.invalidateQueries({
        queryKey: getOrgArtifactsQueryKey({
          query: {
            investigationId
          }
        })
      });
    };
    t3 = [selectedOptionId, artifacts, queryClient, investigationId];
    $[1] = artifacts;
    $[2] = investigationId;
    $[3] = queryClient;
    $[4] = selectedOptionId;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
};
export default useResolveSelectedArtifact;